module.exports = __webpack_public_path__ + "static/img/sys-logo.3c21e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo/sys-logo.png
// module id = Nv3Y
// module chunks = 1